<button
    class="transparent"
    type="button"
    iconPos="left"
    (click)="notifySelectAllItems()"
    hisImage="TICK_MASS">
    <span>{{'genericSearch.selectAll'| hisUi}}</span>
</button>
<button
    class="transparent"
    type="button"
    iconPos="left"
    (click)="notifyClearSelectedItems()"
    hisImage="PANEL_CLOSE">
    <span>{{'genericSearch.clearSelectedItems'| hisUi}}</span>
</button>
